import { Controller } from '@hotwired/stimulus'

// Adds `is-visible` to the element (and any [data-reveal-target="item"] children)
// the first time it scrolls into view, kicking off CSS entrance + mock animations.
// Respects prefers-reduced-motion by revealing immediately with no observer.
export default class extends Controller {
  static targets = ['item']

  connect() {
    const items = this.hasItemTarget ? this.itemTargets : [this.element]

    if (this.prefersReducedMotion) {
      items.forEach((el) => el.classList.add('is-visible'))
      return
    }

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          entry.target.classList.add('is-visible')
          observer.unobserve(entry.target)
        })
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    )

    items.forEach((el) => this.observer.observe(el))
  }

  disconnect() {
    this.observer?.disconnect()
  }

  get prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
  }
}
